interface LockClosedIconProps {
  className?: string;
}

function LockClosedIcon({ className }: LockClosedIconProps) {
  return (
    <svg
      className={className}
      display="inline-block"
      fill="none"
      height="24"
      viewBox="0 0 24 24"
      width="24"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M17.625 11.125H17.0625V8.3125C17.0625 5.53516 14.7773 3.25 12 3.25C9.1875 3.25 6.9375 5.53516 6.9375 8.3125V11.125H6.375C5.10938 11.125 4.125 12.1094 4.125 13.375V19C4.125 20.2305 5.10938 21.25 6.375 21.25H17.625C18.8555 21.25 19.875 20.2305 19.875 19V13.375C19.875 12.1445 18.8555 11.125 17.625 11.125ZM13.125 16.75C13.125 17.3477 12.5977 17.875 12 17.875C11.3672 17.875 10.875 17.3477 10.875 16.75V15.625C10.875 14.9922 11.3672 14.5 12 14.5C12.5977 14.5 13.125 14.9922 13.125 15.625V16.75ZM14.8125 11.125H9.1875V8.3125C9.1875 6.76562 10.418 5.5 12 5.5C13.5469 5.5 14.8125 6.76562 14.8125 8.3125V11.125Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default LockClosedIcon;
